export default __webpack_public_path__ + "adab44511c2a2587f3c170937d8957c4.png";